<template>
  <div class="container">

    <div class="topBox">
      <h1>套餐管理</h1>
      <el-button type="primary" @click="onClickAddNewData()">添加套餐</el-button>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="imageList" label="图片" width="150">
        <template #default="{ row }">
          <div class="imgBox">
            <img v-if="row.imageList && row.imageList.length > 0" :src="row.imageList[0].url" alt="图片" />
            <span v-if="row.imageList">*{{ row.imageList.length }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="nameZh" label="标题" width="300" />
      <el-table-column prop="price" label="价格" width="100">
        <template #default="{ row }">
          ¥{{ row.price }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="200" />

      <el-table-column fixed="right" label="操作" min-width="120">
        <template #default="{ row }">
          <el-button link type="primary" size="small" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button link type="danger" size="small" @click="handleShowDeleteDialog(row)">
            删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>



    <el-dialog v-model="dialogFormVisible" title="编辑套餐" width="800">
      <el-form :model="currentCarData" ref="ruleFormRef" :rules="rules">

        <el-row>
          <el-col :span="24">
            <el-form-item label="相关图片" prop="WeddingImages">
              <div class="avatar-container">
                <div class="avatar-box" v-for="(item, index) in imageArray" :key="item.id">
                  <el-image class="avatar" :src="item.url" fit="cover" />

                  <Delete class="delete-icon" style="width: 1em; height: 1em;" @click="removeImage1(index)" />

                </div>

                <el-upload v-if="imageArray.length < 7" ref="upload" class="upload-demo" :limit="1"
                  :before-upload="beforeUpload" :show-file-list="false">

                  <div class="avatar-box">
                    <FolderAdd class="uploader-icon" style="width: 1em; height: 1em;" />
                  </div>

                </el-upload>


              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="维语套餐名称" prop="name">
              <el-input v-model="currentCarData.name" autocomplete="off" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="中文套餐名称" prop="nameZh">
              <el-input v-model="currentCarData.nameZh" autocomplete="off" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="套餐价格" prop="price">
              <el-input v-model="currentCarData.price" type="number" min="0" required></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="类型" prop="weddingStyle">
              <el-select v-model="currentCarData.weddingStyle" placeholder="请选择分类">
                <el-option v-for="item in categories" :key="item.id" :label="item.label" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="场地" prop="site">
              <el-radio-group v-model="currentCarData.site">
                <el-radio :label="1">室内</el-radio>
                <el-radio :label="2">户外</el-radio>
                <el-radio :label="3">草坪</el-radio>
                <el-radio :label="4">农村</el-radio>
              </el-radio-group>
            </el-form-item>

          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col class="dialog-el" :span="24">
            <el-form-item label="婚礼人员" prop="commodity">
              <el-checkbox-group v-model="checkList1">
                <el-checkbox v-for="item in categoriesPersonnel" :key="item.id" :value="item.id"
                  :disabled="item.disabled">
                  {{ item.labelZh }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="维语主舞台介绍" prop="mainStage">
              <el-input type="textarea" v-model="currentCarData.mainStage" :rows="4"
                @change="handleMainStageChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="中文主舞台介绍" prop="mainStageZh">
              <el-input type="textarea" v-model="currentCarData.mainStageZh" :rows="4"
                @change="handleMainStageZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="维语迎宾区介绍" prop="welcomeArea">
              <el-input type="textarea" v-model="currentCarData.welcomeArea" :rows="4"
                @change="handleWelcomeAreaChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="中文迎宾区介绍" prop="welcomeAreaZh">
              <el-input type="textarea" v-model="currentCarData.welcomeAreaZh" :rows="4"
                @change="handleWelcomeAreaZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="维语花艺细节介绍" prop="floralDetail">
              <el-input type="textarea" v-model="currentCarData.floralDetail" :rows="4"
                @change="handleFloralDetailChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="中文花艺细节介绍" prop="floralDetailZh">
              <el-input type="textarea" v-model="currentCarData.floralDetailZh" :rows="4"
                @change="handleFloralDetailZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col class="dialog-el" :span="24">
            <el-form-item label="维语灯光舞美" prop="lightingAndChoreography">
              <el-input type="textarea" v-model="currentCarData.lightingAndChoreography" :rows="4"
                @change="handleLightingAndChoreographyChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="中文灯光舞美" prop="lightingAndChoreographyZh">
              <el-input type="textarea" v-model="currentCarData.lightingAndChoreographyZh" :rows="4"
                @change="handleLightingAndChoreographyZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col class="dialog-el" :span="24">
            <el-form-item label="维语须知" prop="description">
              <el-input type="textarea" v-model="currentCarData.description" :rows="4"
                @change="handleDescriptionChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="中文须知" prop="descriptionZh">
              <el-input type="textarea" v-model="currentCarData.descriptionZh" :rows="4"
                @change="handleDescriptionZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="success" @click="dialogMuBan = true">查看实例模板</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onClickAddData(ruleFormRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogVisible" title="提示" width="300" :before-close="handleClose">
      <span>删除后无法恢复，确定要删除么？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDelete()">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>


    <el-dialog v-model="dialogMuBan" title="乐队套餐模板" width="600">

      <el-row :gutter="20">
        <el-col :span="12">
          <h4>参考模板</h4>

          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">

            <el-carousel height="250px">
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://img1.baidu.com/it/u=3899887624,3387543768&fm=253&fmt=auto&app=138&f=JPEG?w=1200&h=800"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://qcloud.dpfile.com/pc/qQ_sP3W9vg7jXzHINoNKzjny4O2m4Ua4mecE18fkWpCkjN8bNUIedMn0CzPJ61Sv.jpg"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 250px"
                  src="https://wx3.sinaimg.cn/mw690/752229ebly1hqsghzu8c0j21qi15onpd.jpg" fit="cover" />
              </el-carousel-item>
            </el-carousel>

            <span style="font-size: 14px;color: black;margin: 10px 10px; text-align: left; 
        display: block;">与你同行，不介路远</span>


            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <span style="font-size: 14px;color: red;">￥5000</span>
              <span style="font-size: 12px; margin-left: 10px;
                 background-color: #f5f5f5; 
                 border-radius: 4px;        
                 padding: 2px 8px;        
                 display: inline-block;">婚礼</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
                 border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">产品详情</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">场地</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">室内</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">婚礼人员</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">主持人，化妆师，摄影师</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">主舞台</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                主舞台背景造型设计<br>
                主舞台造型搭建<br>
                定制logo设计制作<br>
                定制主题底纹制作<br>

                爱情通道T台搭建<br>
                时尚路引一组结合全厅T台标配<br>
                双层白+色系一次性地毯一套<br>
                副仪式区造型搭建+装饰<br>
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">迎宾区</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                迎宾区主题纱幔+背景框架固定（多样式并用）<br>
                精美高端签到台桌布<br>
                迎宾区婚纱照X展架<br>
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">花艺细节</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                常规鲜花及配饰类花艺<br>
                常规婚礼头车鲜花造型<br>
                婚礼尾车拉花标配<br>
                新娘手捧花一束<br>
                新郎新娘胸花同色系2支<br>
                新人父母胸花+伴郎伴娘胸花<br>
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">灯光细节</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                面光灯12台<br>
                优质地灯<br>
                1500w追光灯两台<br>
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">须知</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                赠送婚礼当前接亲车队使用：限市区<br>
                头车：奔驰E系<br>
                尾车：五辆奥迪A6L<br>
              </span>
            </div>

          </div>

        </el-col>
        <el-col :span="12">
          <h4>您编辑的</h4>
          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">
            <el-carousel height="250px">
              <el-carousel-item v-for="(image, index) in currentCarData.imageList" :key="index">
                <el-image style="width: 100%; height: 250px" :src="image.url" fit="cover" />
              </el-carousel-item>
            </el-carousel>

            <span style="font-size: 14px;color: black;margin: 10px 10px; text-align: left; 
        display: block;">{{ currentCarData.nameZh }}</span>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <span style="font-size: 14px;color: red;">￥{{ currentCarData.price }}</span>
              <span style="font-size: 12px; margin-left: 10px;
                 background-color: #f5f5f5; 
                 border-radius: 4px;        
                 padding: 2px 8px;        
                 display: inline-block;">{{ getWeddingStyle(currentCarData.weddingStyle) }}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
                 border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">产品详情</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">场地</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{ getSiteType(currentCarData.site)
                }}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">婚礼人员</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{
                getPersonnelData(currentCarData.personnel)
                }}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">主舞台</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                {{ currentCarData.mainStageZh }}
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">迎宾区</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                {{ currentCarData.welcomeAreaZh }}
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">花艺细节</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                {{ currentCarData.floralDetailZh }}
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">灯光细节</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                {{ currentCarData.lightingAndChoreographyZh }}
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">须知</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;text-align: start;">
                {{ currentCarData.descriptionZh }}
              </span>
            </div>



          </div>

        </el-col>
      </el-row>

    </el-dialog>


  </div>
</template>

<script>
import { ref, computed, onMounted, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { get, upload, post } from '@/api/http';
import { useStore } from 'vuex';


export default {
  name: 'PhotosPage',
  setup() {
    const store = useStore();

    const tableData = ref([]);
    const categories = ref([]);
    const categoriesPersonnel = ref([]);
    const currentCarData = ref(null);
    const dialogFormVisible = ref(false);
    const imageArray = ref([]);
    const checkList1 = ref([]);
    const ruleFormRef = ref(null);

    const dialogVisible = ref(false);
    const dialogMuBan = ref(false);



    const shopId = computed(() => {
      const shop = store.state.shop;
      return shop ? shop.id : '';
    });


    // 表单验证规则
    const rules = reactive({
      WeddingImages: [
        {
          validator: (rule, value, callback) => {

            if (imageArray.value.length <= 0) {
              callback(new Error('请选择图片'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],
      price: [{ required: true, message: '请输入价格', trigger: 'blur' }, {
        validator: (rule, value, callback) => {
          if (value < 0) {
            callback(new Error('价格不能为负数'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      name: [{ required: true, message: '请输入维语名称', trigger: 'blur' }],
      nameZh: [{ required: true, message: '请输入中文名称', trigger: 'blur' }],
      site: [{ required: true, message: '请选择场地', trigger: 'change' }],
      mainStage: [{ required: true, message: '请输入维语主舞台策划内容', trigger: 'blur' }],
      mainStageZh: [{ required: true, message: '请输入中文主舞台策划内容', trigger: 'blur' }],
      welcomeArea: [{ required: true, message: '请输入维语迎宾区策划内容', trigger: 'blur' }],
      welcomeAreaZh: [{ required: true, message: '请输入中文迎宾区策划内容', trigger: 'blur' }],
      floralDetail: [{ required: true, message: '请输入维语花艺细节', trigger: 'blur' }],
      floralDetailZh: [{ required: true, message: '请输入中文花艺细节', trigger: 'blur' }],
      lightingAndChoreography: [{ required: true, message: '请输入维语灯光舞美', trigger: 'blur' }],
      lightingAndChoreographyZh: [{ required: true, message: '请输入中文灯光舞美', trigger: 'blur' }],
      description: [{ required: true, message: '请输入维语须知', trigger: 'blur' }],
      descriptionZh: [{ required: true, message: '请输入中文须知', trigger: 'blur' }],
      weddingStyle: [{ required: true, message: '请选择类型', trigger: 'change' }],

    });


    onMounted(() => {
      getCategoryData();
      getData();
    });

    const getCategoryData = async () => {
      try {
        const response = await get('adminCategories/getCategoriesByParentId/10')
        if (response.code === 200) {

          categoriesPersonnel.value = response.data[0].children;
          categories.value = response.data[1].children;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }


    const getData = async () => {
      try {
        const response = await get('adminWeddingPlan/allShopPlan', { "shopId": shopId.value })
        if (response.code === 200) {
          tableData.value = response.data;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }

    const addData = async () => {

      let personnel = checkList1.value.join(',');

      const dataParam = {
        'price': currentCarData.value.price,
        'name': currentCarData.value.name,
        'nameZh': currentCarData.value.nameZh,
        'personnel': personnel,
        'site': currentCarData.value.site,
        'mainStage': currentCarData.value.mainStage,
        'mainStageZh': currentCarData.value.mainStageZh,
        'welcomeArea': currentCarData.value.welcomeArea,
        'welcomeAreaZh': currentCarData.value.welcomeAreaZh,
        'floralDetail': currentCarData.value.floralDetail,
        'floralDetailZh': currentCarData.value.floralDetailZh,
        'lightingAndChoreography': currentCarData.value.lightingAndChoreography,
        'lightingAndChoreographyZh': currentCarData.value.lightingAndChoreographyZh,
        'description': currentCarData.value.description,
        'descriptionZh': currentCarData.value.descriptionZh,
        'weddingStyle': currentCarData.value.weddingStyle,
        'imagesId': currentCarData.value.imagesId,
        'shopId': shopId.value,
        'status': currentCarData.value.status,
      };

      if (currentCarData.value.id) {
        dataParam.id = currentCarData.value.id;
      }


      try {
        const response = await post('adminWeddingPlan/addPlan', dataParam)
        if (response.code === 200) {
          dialogFormVisible.value = false;
          ElMessage.success("保存成功");
          getData();
        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }


    }



    const uploadFile = async (file) => {
      await upload('adminUpload/image', file, { 'type': 21 })
        .then(response => {

          if (response.code == 200) {
            imageArray.value.push(response.data);
            currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');
          } else {
            ElMessage.error('上传失败，请重试')
          }

        })
        .catch(error => {
          console.error('请求失败', error)
          ElMessage.error('请求失败，请重试')
        });
    }

    const deleteData = async (id) => {
      await get('adminResourse/deleteResourse/' + id)
        .then(() => {
          ElMessage.success("删除成功");
        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const beforeUpload = (file) => {


      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'
      const isLt200KB = file.size / 1024 <= 200;

      if (!isImage) {
        ElMessage.error('请选择图片')
        return false;
      }

      if (!isLt200KB) {
        ElMessage.error('图片大小超过了200KB')
        return false;
      }

      uploadFile(file);
      return false; // 阻止默认上传行为
    }

    const deletePlanData = async (id) => {
      await get('adminWeddingPlan/deletePlan/' + id)
        .then(() => {
          ElMessage.success("删除成功");
          dialogVisible.value = false;
        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const handleEdit = (item) => {
      // 打印或处理编辑数据
      currentCarData.value = item;
      imageArray.value = item.imageList;

      if (item.personnel != null) {
        checkList1.value = item.personnel.split(',').map(Number);
      }

      dialogFormVisible.value = true;
    };

    const onClickAddNewData = () => {

      currentCarData.value = {};
      imageArray.value = [];
      checkList1.value = [];
      dialogFormVisible.value = true;


    }

    const onClickAddData = async (formEl) => {
      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    const removeImage1 = (index) => {
      if (imageArray.value[index] && imageArray.value[index].id) {
        deleteData(imageArray.value[index].id);
        imageArray.value.splice(index, 1);
        currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');
      } else {
        console.error("该图片对象没有 id 属性！");
      }
    }

    const handleShowDeleteDialog = (row) => {
      currentCarData.value = row;
      dialogVisible.value = true;
    }

    const handleDelete = () => {
      deletePlanData(currentCarData.value.id);
    }

    const getSiteType = (site) => {
      switch (site) {
        case 1:
          return "室内";
        case 2:
          return "户外";
        case 3:
          return "草坪";
        case 4:
          return "农村";
        default:
          return "未定义";
      }
    }

    const getWeddingStyle = (style) => {
      switch (style) {
        case 109:
          return "婚礼";
        case 110:
          return "接亲";
        case 111:
          return "割礼";
        case 112:
          return "花茶";
        case 113:
          return "求婚";
        default:
          return "未定义";
      }
    }


    const getPersonnelData = (personnel) => {
      const list = personnel.split(',').map(Number);

      const names = list.map(id => {
        const item = categoriesPersonnel.value.find(item => item.id === id);
        return item ? item.labelZh : '';
      }).filter(label => label);

      return names.join(', ');
    }


    const handleMainStageChange = (val) => {
      currentCarData.value.mainStage = val.replace(/\r?\n/g, '\n')
    }

    const handleMainStageZhChange = (val) => {
      currentCarData.value.mainStageZh = val.replace(/\r?\n/g, '\n')
    }

    const handleWelcomeAreaChange = (val) => {
      currentCarData.value.welcomeArea = val.replace(/\r?\n/g, '\n')
    }

    const handleWelcomeAreaZhChange = (val) => {
      currentCarData.value.welcomeAreaZh = val.replace(/\r?\n/g, '\n')
    }

    const handleFloralDetailChange = (val) => {
      currentCarData.value.floralDetail = val.replace(/\r?\n/g, '\n')
    }

    const handleFloralDetailZhChange = (val) => {
      currentCarData.value.floralDetailZh = val.replace(/\r?\n/g, '\n')
    }

    const handleLightingAndChoreographyChange = (val) => {
      currentCarData.value.lightingAndChoreography = val.replace(/\r?\n/g, '\n')
    }

    const handleLightingAndChoreographyZhChange = (val) => {
      currentCarData.value.lightingAndChoreographyZh = val.replace(/\r?\n/g, '\n')
    }

    const handleDescriptionChange = (val) => {
      currentCarData.value.description = val.replace(/\r?\n/g, '\n')
    }

    const handleDescriptionZhChange = (val) => {
      currentCarData.value.descriptionZh = val.replace(/\r?\n/g, '\n')
    }



    return {
      tableData,
      categories,
      currentCarData,
      handleEdit,
      dialogFormVisible,
      imageArray,
      checkList1,
      onClickAddData,
      onClickAddNewData,
      rules,
      ruleFormRef,
      removeImage1,
      beforeUpload,
      uploadFile,
      dialogVisible,
      handleShowDeleteDialog,
      handleDelete,
      categoriesPersonnel,
      dialogMuBan,
      getSiteType,
      getWeddingStyle,
      getPersonnelData,
      handleMainStageChange,
      handleMainStageZhChange,
      handleWelcomeAreaChange,
      handleWelcomeAreaZhChange,
      handleFloralDetailChange,
      handleFloralDetailZhChange,
      handleLightingAndChoreographyChange,
      handleLightingAndChoreographyZhChange,
      handleDescriptionChange,
      handleDescriptionZhChange,
    }



  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.topBox {
  display: flex;
  justify-content: space-between;

}

.imgBox {
  display: flex;
  align-items: center;
}

.imgBox img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 10px;
}

.avatar-container {
  display: flex;
  flex-wrap: wrap;
}

.avatar-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;

}

.avatar-box:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10%;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  color: white;
}

.delete-icon:hover {
  color: #409EFF;
}

.uploader-icon {
  font-size: 25px;
  color: #8c939d;
  text-align: center;
  margin-top: 50%;
  transform: translate(0%, -50%);
}
</style>
